require('../../../candidates/search/jv.search.config.service');
const {App, react2angular} = require('../../../../react-dist/reqsCandidateComponent').reactLibrary; // eslint-disable-line

angular.module('jv.React.CandidateComponent',[
    'jv.candidates.service',
    'jv.search.config.service'
])
.component('reactReqsCandidateComponent', react2angular(App, ['jobDetails', 'candidateService', 'configService', 'translations'])) // eslint-disable-line